import React from 'react';

import { GetAttachmentDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { AttachmentPreviewLink } from '../Attachment/AttachmentPreviewLink';

export const ManualAttachmentsPreview = (props: {
  attachments?: GetAttachmentDto[] | null;
}) => {
  if (!props.attachments?.length) {
    return null;
  }

  return (
    <>
      {props.attachments.map(attachment => (
        <AttachmentPreviewLink
          key={attachment.id}
          attachmentId={attachment.id}
          attachmentName={attachment.name || ''}
          tooltipText={attachment.name || 'Podgląd'}
        />
      ))}
    </>
  );
};
